import lengthOfArrayLike$1 from './length-of-array-like.js';

var lengthOfArrayLike = lengthOfArrayLike$1;

var arrayFromConstructorAndList = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);

  while (length > index) result[index] = list[index++];

  return result;
};

export { arrayFromConstructorAndList as default };
